// extracted by mini-css-extract-plugin
export default {"page":"_Q-z","cartModal":"aR-z","checkout":"bR-z","placeholder":"cR-z","account":"dR-z"};